module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-tabs', {
    staticClass: "white",
    attrs: {
      "dark": ""
    },
    model: {
      value: (_vm.active_tab),
      callback: function($$v) {
        _vm.active_tab = $$v
      },
      expression: "active_tab"
    }
  }, [_c('content-top-header', {
    staticClass: "content-top-header-tab",
    attrs: {
      "height": 62
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.signups_tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        'active tab-active': tab.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (tab.id))
      },
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_c('label', {
      staticClass: "innerBold"
    }, [_vm._v(_vm._s(tab.title))])])
  }))])], 2), _vm._v(" "), _c('v-tabs-items', {
    staticStyle: {
      "border": "none"
    }
  }, _vm._l((_vm.signups_tabs), function(tab) {
    return _c('v-tabs-content', {
      key: tab.id,
      attrs: {
        "id": tab.id
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.active_tab == 'waiting') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._.get(props.item, "genre.name", "")) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.inviter) ? _c('router-link', {
            attrs: {
              "to": ("/" + (props.item.inviter.slug))
            }
          }, [_vm._v(_vm._s(props.item.inviter.username))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            staticClass: "pb-2"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "black"
            }
          }, [_vm._v("\n                          error\n                        ")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" View info ")])], 1)]), _vm._v(" "), _c('v-list-tile', {
            staticClass: "display-flex justify-center algin-center gap-8"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "red"
            }
          }, [_vm._v("error")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" Flag user ")])], 1)])], 1)], 1)], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'co-signed') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      on: {
        "update:pagination": function($event) {
          _vm.pagination = $event
        }
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._.get(props.item, "genre.name", "")) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('label', {
            class: {
              'status-accepted': props.item.status == 'Accepted',
              'status-expired': props.item.status == 'Expired',
              'status-pending': props.item.status == 'Pending',
            }
          }, [_vm._v(_vm._s(props.item.status))])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [(props.item.inviter) ? _c('router-link', {
            attrs: {
              "to": ("/" + (props.item.inviter.slug))
            }
          }, [_vm._v(_vm._s(props.item.inviter.username))]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-xs-right"
          }, [_c('v-menu', {
            attrs: {
              "offset-y": ""
            }
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
            staticClass: "pb-2"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "black"
            }
          }, [_vm._v("\n                          error\n                        ")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" View info ")])], 1)]), _vm._v(" "), _c('v-list-tile', {
            staticClass: "display-flex justify-center algin-center gap-8"
          }, [_c('div', {
            staticClass: "cursor-pointer display-flex justify-center algin-center gap-8",
            on: {
              "click": function($event) {
                _vm.denyButtonAction()
              }
            }
          }, [_c('v-icon', {
            staticClass: "icon-error",
            attrs: {
              "color": "red"
            }
          }, [_vm._v("error")]), _vm._v(" "), _c('span', {
            staticClass: "text-poppins-15"
          }, [_vm._v(" Flag user ")])], 1)])], 1)], 1)], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e(), _vm._v(" "), (_vm.active_tab == 'approved' || _vm.active_tab == 'denied') ? _c('v-data-table', {
      staticClass: "user-table custom-data-table pt-70 px-4",
      attrs: {
        "headers": _vm.headers,
        "items": _vm.signups,
        "pagination": _vm.pagination,
        "rows-per-page-items": _vm.per_page_options,
        "total-items": _vm.total_signups
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "text-xs-left"
          }, [_c('div', {
            staticClass: "avatar-image-wrapper ml-4 display-flex align-center gap-10"
          }, [_c('div', {
            staticClass: "avatar-image",
            style: ({
              'background-image': 'url(' + props.item.avatar.url + ')',
            })
          }), _vm._v(" "), _c('div', [_c('div', {
            staticClass: "avatar-title"
          }, [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('div', {
            staticClass: "avatar-title text-back-80"
          }, [_vm._v("\n                      @" + _vm._s(props.item.slug) + "\n                    ")])])])]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(_vm._f("capitalize")(props.item.request_role)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.created_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center"
          }, [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(props.item.approved_at)) + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_vm._v("\n                " + _vm._s(props.item.approver ? props.item.approver.username : "") + "\n              ")]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-left"
          }, [_c('v-btn', {
            staticClass: "signups-btn",
            attrs: {
              "color": "primary"
            },
            nativeOn: {
              "click": function($event) {
                _vm.openApproveModal(props.item)
              }
            }
          }, [_vm._v("Click to view")])], 1)]
        }
      }, {
        key: "pageText",
        fn: function(ref) {
          var pageStart = ref.pageStart;
          var pageStop = ref.pageStop;

          return [_vm._v("\n              From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + " out of\n              " + _vm._s(_vm.total_signups) + "\n            ")]
        }
      }])
    }) : _vm._e()], 1)], 1)
  }))], 1), _vm._v(" "), (_vm.show_approve_modal) ? _c('signup-approve-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.closeApproveModal,
      "approveButtonAction": _vm.approveUser,
      "denyButtonAction": _vm.denyUser,
      "activeTab": _vm.active_tab,
      "loading": _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_deny_modal) ? _c('signup-deny-modal', {
    attrs: {
      "item": _vm.user,
      "dismiss": _vm.closeDenyModal,
      "submission": _vm.viewSubmission,
      "loading": _vm.loading
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6469ac4d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/components/signups.vue
// module id = 1752
// module chunks = 180